export const SG_CHANGE_INPUT_VALUE = 'SG_CHANGE_INPUT_VALUE';
export const SG_FETCH_SECTION_DATA = 'SG_FETCH_SECTION_DATA';
